import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { DEFAULT_NAMESPACE } from './namespaces';
import { SUPPORTED_LANGUAGE_CODES } from './languages';

// Use import.meta.glob with ** so nested namespaces (e.g. `learn/common`,
// which lives at `locales/<lng>/learn/common.json`) are picked up. A bare
// dynamic-import template literal compiles to a glob with `*` per placeholder
// (matches one path segment only), which silently misses nested files.
const localeModules = import.meta.glob<{ default: Record<string, unknown> }>(
  '../locales/**/*.json',
);
const backend = resourcesToBackend(
  async (lng: string, ns: string) => {
    const path = `../locales/${lng}/${ns}.json`;
    const loader = localeModules[path];
    if (!loader) throw new Error(`Missing locale file: ${path}`);
    const mod = await loader();
    return mod.default;
  },
);

// Only the default namespace is preloaded; per-route namespaces lazy-load on
// first useTranslation('foo') via the resourcesToBackend backend, so the home
// route stops paying for the ~16 unused namespace chunks (tracker, builder,
// library, etc.) on every cold load.
void i18n
  .use(backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGE_CODES as string[],
    defaultNS: DEFAULT_NAMESPACE,
    ns: [DEFAULT_NAMESPACE],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'knittime-language',
      caches: ['localStorage'],
    },
    react: { useSuspense: true },
  });

export default i18n;
